import * as BABYLON from '@babylonjs/core/Legacy/legacy';

export enum PathMeshType {
    straight = 1,
    breakDown,
    breakUp,
    coin,
    fire,
    turnLeft,
    turnRight,
}


export interface IMeshPool {
    getMesh(): BABYLON.Mesh
    returnMesh(mesh: BABYLON.Mesh): void;
}